import { RouteType } from 'app/constants/GlobalTypes'
import { useNextUrl } from 'app/lib/hooks/useNextUrl'
import { retry } from 'app/lib/utils/retry'
import Private from 'app/routes/Root'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes as Switch } from 'react-router-dom'

import MainLayout from '../pages/MainLayout'

type PageType = { default: React.ComponentType<{ route: Partial<RouteType> }> }

const AccountsPage = lazy(
  () => retry(() => import('app/pages/Account/Views/index')) as Promise<PageType>
)

// next_url carries the customer prefix, so a full page load leaves the router basename.
const LoginRedirect = () => {
  const { nextUrl } = useNextUrl()

  const { origin } = window.location
  const target = nextUrl && new URL(nextUrl, `${origin}/`)
  const sameOrigin = target && target.origin === origin

  useEffect(() => {
    if (sameOrigin) window.location.replace(target.href)
  }, [nextUrl])

  return sameOrigin ? null : <Navigate to={'/'} />
}

const Main: React.FC = () => {
  return (
    <Switch>
      <Route path={Routes.Authentication.collection().login} element={<LoginRedirect />} />
      <Route
        key="account.index"
        path={Routes.Account.collection().index}
        element={
          <Suspense fallback={null}>
            <AccountsPage route={{ key: 'account.index' }} />
          </Suspense>
        }
      />
      <Route
        path="/*"
        element={
          <MainLayout>
            <Private />
          </MainLayout>
        }
      />
    </Switch>
  )
}

export default Main
